export default __webpack_public_path__ + "src/blocks/pricing-table/icons/state.svg";